import { Box, Text } from "@chakra-ui/layout";
import { Flex, HStack, Stack, Center } from "@chakra-ui/react";
import { RefObject, useEffect, useState } from "react";

import { Nullable, UUID } from "foundation-ts/types";
import { $isfunction, $length, $ok } from "foundation-ts/commons";
import { DocumentDto, SignatureDto } from "doxecure-commons/lib/doxecureClientTypes";
import { DocumentSignaturePosition, SignatureMode } from "doxecure-commons/lib/doxecureTypes";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { G1Button } from "@components/G1Button";
import { Viewer } from "@components/Viewer/Viewer";
import { $g1Color } from "@/theme/G1Style";
import { okOrEmptyCard } from "@utils/functions";
import { G1Icon } from "@utils/icons";
import { LoadingFailedType } from "@utils/viewPDFTypes";

interface DocumentPanelProps {
    document: DocumentDto,
    signatures: SignatureDto[],
    message?: string,
    signatureMode?: SignatureMode,
    viewerRef?: RefObject<HTMLIFrameElement>,
    onRemoveDocument: () => void,
//    onChangeSignatureLines: (lines: uint8) => void,
    onBack: () => void,
    onLoadingFailed?: (type: LoadingFailedType) => void,
    onSaveSignerPosition?: (docId: UUID, docPosition: DocumentSignaturePosition) => void,
    onRemoveSignerPosition?: (docId: UUID, signatureId: UUID) => void
}

export const DocumentPanel = (props: DocumentPanelProps) => {
    const { document, signatures, signatureMode, message, viewerRef, onBack, onRemoveDocument, /*onChangeSignatureLines,*/ onLoadingFailed, onSaveSignerPosition, onRemoveSignerPosition } = props;
//    const [isCheckedSignersAtLastPage, setIsCheckedSignersAtLastPage] = useState(false) ;
    const [documentId, setDocumentId] = useState<Nullable<UUID>>(null);

    // const _handleClickCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    //     setIsCheckedSignersAtLastPage(e.target.checked) ;
    //     onChangeSignatureLines((e.target.checked ? 0 : 3) as uint8) ;
    // }

    useEffect(() => {
        if ($ok(document)) {
//            setIsCheckedSignersAtLastPage(document.lastPageSignRows === 0);
            setDocumentId(document.apid ?? document.localUUID);
        }
    }, [document]);

    return (
        <>
            <ColumnTitle color={$g1Color('global.write')} padding="1% 0">
                <Flex alignItems="center" as="button" onClick={onBack} width="100%">
                    <Center color={$g1Color('global.icons.navigation.previous.write')}><G1Icon.Back /></Center>
                    <Text>Retour</Text>
                </Flex>
            </ColumnTitle>
            <Box marginBottom="2">
                {okOrEmptyCard(document.apid || document.localUUID,
                    <HStack mt="unset" height="auto" display="flex" flexDirection={{ base: "column", sm: "row" }} justifyContent="right">
                        {signatureMode === SignatureMode.Invisible &&  //? <Checkbox isChecked={isCheckedSignersAtLastPage} onChange={_handleClickCheckbox}>Placer les signataires restants sur une nouvelle page</Checkbox>
                            /*:*/ <Text fontSize="medium">Vous avez choisi le mode invisible. Les signataires sont pris en compte mais ils ne sont pas affichés dans le document.</Text>
                        }
                        <Stack margin="5%" display="flex" justifyContent="space-around" width={{ base: "100%", sm: "unset" }} height="100%" flexDirection={{ base: "row", sm: "column" }} spacing={{ base: "unset", sm: "2" }} alignItems="center" paddingTop={{ base: "2%", sm: "unset" }}>
                            <G1Button component="form" variant="delete" title="Retirer" width="100px" fontSize="md" onClick={() => onRemoveDocument()} />
                        </Stack>
                    </HStack>)
                }
            </Box>
            {okOrEmptyCard($length(message)>0,
                <Box marginBottom="5px">
                    <Text fontSize="0.8em" lineHeight="shorter" color="orange" textAlign="center">
                        {message}
                    </Text>
                </Box>
            )}
            <Viewer key={documentId} viewerRef={viewerRef} documents={[document]} forceMobile={true} placingSignersView={signatureMode === SignatureMode.Visible} signatures={signatureMode === SignatureMode.Visible ? signatures : []}
                    immutable={false} lastPageSignRows={document.lastPageSignRows} autoExternalSavePosition={$isfunction(onSaveSignerPosition)} onSaveSignerPosition={onSaveSignerPosition} onRemoveSignerPosition={onRemoveSignerPosition} onLoadingFailed={onLoadingFailed} />
        </>
    );
};
